export function Home() {
    return (
        <div className="h-full"></div>
    );

}